<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="音乐名称">
          <el-input size="small" v-model="searchForm.search" placeholder="请输入音乐名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加音乐</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <!-- v-loading="loading" -->
          <el-table-column prop="name" label="音乐名称" align="center" width="150px">
          </el-table-column>
          <el-table-column prop="image.filePath" align="center" label="音乐图片">
            <template slot-scope="scope">
              <img :src="scope.row.image.filePath" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="file_address" align="center" label="音乐路径"></el-table-column>
          <el-table-column prop="desc" align="center" label="音乐描述"></el-table-column>
          <el-table-column prop="music_sort" align="center" label="排序"></el-table-column>
          <el-table-column prop="is_show" align="center" label="是否显示"	 width="100">
            <template slot-scope="scope">
              <el-switch class="switch" @change='isShow(scope.row)' v-model="scope.row.is_show" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" align="center" width="220">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑音乐</el-button>
              <el-button @click="delClick(scope.row)" type="danger" size="small">删除音乐</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import MusicApi from "@/api/music.js";
export default {
  components: {
    // Add
  },
  data() {
    return {
      tableData: [],
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        search: ""
      },
      is_show: "" //音乐是否显示
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/music/music/add");
    },
    // 是否显示音乐
    isShow(row) {
      let self = this;
      let is_show = "";
      // if (row.is_show == 1) {
      //   is_show = 0; // 更新为0，显示的文本为"否"
      // } else {
      //   is_show = 1; // 更新为1，显示的文本为"是"
      // }
      MusicApi.Musicshow({
        music_id: row.music_id,
        status: row.is_show
      }).then(data => {
        self.$message({
          message: "修改成功",
          type: "success"
        });
        self.getData();
      });
    },
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      MusicApi.MusicList(Params, true)
        .then(data => {
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      console.log(row, "编辑技师");
      this.$router.push({
        path: "/music/music/edit",
        query: {
          music_id: row.music_id,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          MusicApi.Musicdelete({
            music_id: row.music_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/music/music/index.vue